import { PREFIX_API } from 'constants/api.const';
import {
  CloseLedLightRequestModel,
  OpenLedLightRequestModel,
} from 'models/photo/led-light.model';
import qs from 'query-string';
import { baseSliceApi } from './base.slice-api';

export const ledLightApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    openLedLightApiAction: build.mutation<boolean, OpenLedLightRequestModel>({
      query: (payload) => ({
        url: `${PREFIX_API.API}/usb-relay/open?${qs.stringify(payload)}`,
        method: 'POST',
      }),
      extraOptions: { maxRetries: 0 },
    }),
    closeLedLightApiAction: build.mutation<boolean, CloseLedLightRequestModel>({
      query: (payload) => ({
        url: `${PREFIX_API.API}/usb-relay/close?${qs.stringify(payload)}`,
        method: 'POST',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const {
  useOpenLedLightApiActionMutation,
  useCloseLedLightApiActionMutation,
} = ledLightApi;

export const {
  endpoints: { openLedLightApiAction, closeLedLightApiAction },
} = ledLightApi;
